$(document).ready(function()
{
    let current_month = '';
    let current_term = '';
    let current_count = 0;

    $('.apply-filters label').click(function(e) 
    {
        e.preventDefault();
        e.stopPropagation();
        let parent = $(this).parent();
        let el = $(this);

        if (parent.hasClass('expanded'))
        {
            parent.find('label').removeClass('active');
            el.addClass('active');
            parent.removeClass('expanded');
        }
        else
        {
            parent.addClass('expanded');
        }

        let slug = el.find('input').val();
        let section = parent.attr('id');

        applyFilters(section, slug);

    });

    function applyFilters(section, slug)
    {

        if (section == 'applyFilterMonth')
        {
            current_month = slug;
        }
        if (section == 'applyFilterTerm')
        {
            current_term = slug;
        }
        closeAll();
        openSectionsAndCards();

    }

    function closeAll()
    {
        // fade out cards
        $('.event-listing-section .filter-card').each(function(i, obj)
        {
            $(this).fadeOut(300);
        });
        // fade out month containers
        $('.event-listing-section').each(function(i, obj)
        {
            $(this).fadeOut(300);
        });

    }


    function openSectionsAndCards()
    {
        current_count = 0;

        $('.event-listing-section .filter-card').each(function(i, obj)
        {
            let category = $(this).data('category');
            let month = $(this).data('month');
            //console.log(current_month, month);
            if ( (current_month == 'all' || current_month == '' || current_month == month) && (current_term == 'all' || current_term == '' || category.includes(current_term)) )
            {
                $(this).fadeIn(300); 
                $(this).parents('.event-listing-section').fadeIn(300);
                current_count++;
            }
        });          
        $('#totalCount').html("Showing " + current_count + " <span>event" + ( (current_count != 1) ? "s</span>" : '</span>'  ));

        if ( current_count > 0)
        {
            $("#noMatchingEvents").removeClass("active");  
        }
        else
        {
            $("#noMatchingEvents").addClass("active");
        }

    }

});